module.exports = __webpack_public_path__ + "img/image1.13581552.png";